import { formatterFactor } from '@/utilities/format';

type ValuationType = 'PB' | 'PS' | 'PE' | 'n/a';

export interface BestValuationRatio {
  valuationType: ValuationType;
  valuation: number | null;
  valuationFormatted: string;
}

const getValuationRatio = (
  type: ValuationType = 'n/a',
  valuation: number | null = null
) => {
  return {
    valuationType: type,
    valuation,
    valuationFormatted: formatterFactor(valuation),
  };
};

export const getBestValuationRatio = (
  priceToBook: number | null,
  priceToEarnings: number | null,
  priceToSales: number | null,
  industryLabel: string
): BestValuationRatio => {
  if (
    ['Banks', 'Real Estate'].includes(industryLabel) &&
    priceToBook &&
    priceToBook > 0
  ) {
    return getValuationRatio('PB', priceToBook);
  }

  if (priceToEarnings && priceToEarnings > 0) {
    return getValuationRatio('PE', priceToEarnings);
  }

  if (priceToSales && priceToSales > 0) {
    return getValuationRatio('PS', priceToSales);
  }

  if (priceToBook && priceToBook > 0) {
    return getValuationRatio('PB', priceToBook);
  }

  if (priceToEarnings) {
    return getValuationRatio('PE', priceToEarnings);
  }

  return getValuationRatio();
};
